module.exports = __webpack_public_path__ + "img/yt-pendle_eth_slp.e7dd5132.png";